import { Directive, ElementRef, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';

/** Só aplica o `src` quando o elemento chega perto da viewport.
 *
 *  No grid do explorar, cada post de vídeo sem miniatura vira um `<video>`; com
 *  `[src]` direto o navegador abre uma conexão por célula assim que a página
 *  monta, e vídeo do feed é servido direto do S3 (não passa pelo CDN). Aqui só
 *  as células que o usuário realmente alcança custam requisição.
 */
@Directive({
  selector: '[appLazySrc]',
  standalone: true,
})
export class LazySrcDirective implements OnInit, OnChanges, OnDestroy {
  @Input('appLazySrc') src: string | null = null;

  /** Uma vez visto, fica carregado — não vale desfazer ao sair da tela. */
  private visivel = false;
  private io?: IntersectionObserver;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngOnInit(): void {
    if (typeof IntersectionObserver === 'undefined') {
      this.aplica();               // navegador sem suporte: comportamento antigo
      return;
    }
    this.io = new IntersectionObserver(
      entries => {
        if (entries.some(e => e.isIntersecting)) {
          this.aplica();
          this.desliga();
        }
      },
      { rootMargin: '200px 0px' }
    );
    this.io.observe(this.el.nativeElement);
  }

  /** *ngFor com trackBy reaproveita o nó e só troca o binding: se o elemento já
   *  estava visível, a nova URL precisa entrar na hora. */
  ngOnChanges(): void {
    if (this.visivel) this.aplica();
  }

  ngOnDestroy(): void {
    this.desliga();
  }

  private aplica(): void {
    this.visivel = true;
    if (this.src) this.el.nativeElement.setAttribute('src', this.src);
  }

  private desliga(): void {
    this.io?.disconnect();
    this.io = undefined;
  }
}
